import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import Vue from 'vue'
import { sentryClientEnv, sentryClientDsn } from '~/constants'

const SENTRY_RELEASE = process.env.VUE_APP_SENTRY_RELEASE

if (sentryClientEnv === 'staging' || sentryClientEnv === 'production') {
  Sentry.init({
    dsn: sentryClientDsn,
    environment: sentryClientEnv,
    release: SENTRY_RELEASE,
    debug: sentryClientEnv === 'staging' || sentryClientEnv === 'local',
    /**
     * Performance monitoring,
     * currently disabled.
     */
    tracesSampleRate: sentryClientEnv === 'staging' ? 1.0 : 0.2, // Be sure to lower this in production
    integrations: [
      new Integrations.BrowserTracing(),
      new VueIntegration({
        Vue,
        tracing: false,
        attachProps: true,
      }),
    ],
  })
} else {
  console.debug('Not configuring Sentry, environment is', sentryClientEnv)
}
